export enum PaymentMethod {
	SYSTEM = 'S',
	PAYPAL = 'P',
	GOOGLE = 'G',
	APPLE = 'A',
	SYSTEM_ADMIN = 'SA'
}

export enum Environment {
	PRODUCTION = 'production',
	DEV = 'development',
	STAGING = 'staging',
	FEEDBACK = 'feedback'
}

export enum OBSThemes {
	Default = 'default',
	Light = 'light',
	Dark = 'dark',
	Stoked = 'stocked',
	Joyn = 'joyn'
}

export enum PermissionList {
	// Full Access
	FullAccess = 'FullAccess',

	// My Account
	AccountMe = 'AccountMe',
	AccountUpdate = 'AccountUpdate',
	AccountChangePassword = 'AccountChangePassword',

	// Storage
	StorageGetCredentials = 'StorageGetCredentials',

	// Roles
	RolesAdd = 'RolesAdd',
	RolesList = 'RolesList',
	RolesUpdate = 'RolesUpdate',
	RolesDelete = 'RolesDelete',
	RolesPermissionsAssign = 'RolesPermissionsAssign',

	// User Management
	UserCreate = 'UserCreate',
	UserList = 'UserList',
	UserUpdate = 'UserUpdate',
	UserStatusUpdate = 'UserStatusUpdate',
	UserDelete = 'UserDelete',
	UserSetCreator = 'UserSetCreator',

	// Energy Package
	EnergyPackageAdd = 'EnergyPackageAdd',
	EnergyPackageList = 'EnergyPackageList',
	EnergyPackageUpdate = 'EnergyPackageUpdate',
	EnergyPackageDelete = 'EnergyPackageDelete',

	// Creators
	CreatorList = 'CreatorList',
	CreatorView = 'CreatorView',
	CreatorStatusUpdate = 'CreatorStatusUpdate',
	CreatorAdd = 'CreatorAdd',
	CreatorUpdate = 'CreatorUpdate',
	CreatorArchive = 'CreatorArchive',
	CreatorDelete = 'CreatorDelete',
	ShowListByCreator = 'ShowListByCreator',
	CreatorSubscriptionActive = 'CreatorSubscriptionActive',
	CreatorSubscriptionHistory = 'CreatorSubscriptionHistory',
	CreatorSubscriptionAdd = 'CreatorSubscriptionAdd',
	CreatorSubscriptionUpdate = 'CreatorSubscriptionUpdate',
	CreatorInfoPostsAdd = 'CreatorInfoPostsAdd',
	CreatorInfoPostsUpdate = 'CreatorInfoPostsUpdate',
	CreatorInfoPostsDelete = 'CreatorInfoPostsDelete',
	CreatorInfoPostsVisibility = 'CreatorInfoPostsVisibility',
	CreatorInfoPostsList = 'CreatorInfoPostsList',
	CreatorPayoutPercentage = 'CreatorPayoutPercentage',
	CreatorMasterOtp = 'CreatorMasterOtp',
	CreatorForceLogout = 'CreatorForceLogout',
	CreatorVoiceMail = 'CreatorVoiceMail',
	CreatorCallForward = 'CreatorCallForward',
	CreatorTemplateMessageGet = 'CreatorTemplateMessageGet',
	CreatorTemplateMessageUpdate = 'CreatorTemplateMessageUpdate',
	CreatorSmsCreditAdd = 'CreatorSmsCreditAdd',
	CreatorBlockLimitGet = 'CreatorBlockLimitGet',
	CreatorBlockLimitUpdate = 'CreatorBlockLimitUpdate',
	CreatorDownloadFans = 'CreatorDownloadFans',
	CreatorExport = 'CreatorExport',
	CreatorPhoneNumberStatus = 'CreatorPhoneNumberStatus',
	CreatorBrandUpdate = 'CreatorBrandUpdate',
	CreatorCreditNoteView = 'CreatorCreditNoteView',

	// Payouts
	PayoutsGet = 'PayoutsGet',
	PayoutApprove = 'PayoutApprove',

	// Creator Config
	CreatorConfigList = 'CreatorConfigList',
	CreatorConfigUpdate = 'CreatorConfigUpdate',
	CreatorConfigPlanList = 'CreatorConfigPlanList',
	CreatorConfigPlanDelete = 'CreatorConfigPlanDelete',
	CreatorConfigPlanUpdate = 'CreatorConfigPlanUpdate',

	// Rewards
	RewardList = 'RewardList',
	RewardAdd = 'RewardAdd',
	RewardView = 'RewardView',
	RewardDuplicate = 'RewardDuplicate',
	RewardUpdate = 'RewardUpdate',
	RewardDelete = 'RewardDelete',
	RewardSetWinner = 'RewardSetWinner',
	CatchThePrizeBoard = 'CatchThePrizeBoard',
	BanCatchThePrizeUser = 'BanCatchThePrizeUser',
	UnbanCatchThePrizeUser = 'UnbanCatchThePrizeUser',
	BanAndUnBanUserList = 'BanAndUnBanUserList',

	// Interactions
	InteractionList = 'InteractionList',
	InteractionAdd = 'InteractionAdd',
	InteractionDuplicate = 'InteractionDuplicate',
	InteractionView = 'InteractionView',
	InteractionUpdate = 'InteractionUpdate',
	InteractionDelete = 'InteractionDelete',

	// OBS
	OBSConfigView = 'OBSConfigView',
	OBSConfigUpdate = 'OBSConfigUpdate',
	OBSElementActivate = 'OBSElementActivate',
	OBSElementClear = 'OBSElementClear',
	OBSElementLeaderboard = 'OBSElementLeaderboard',
	OBSElementReferUrl = 'OBSElementReferUrl',
	OBSElementChatBoxActivate = 'OBSElementChatBoxActivate',
	OBSGetActiveReferUrl = 'OBSGetActiveReferUrl',

	// Polls
	PollEnd = 'PollEnd',
	PollStart = 'PollStart',
	PollUpdate = 'PollUpdate',
	PollDelete = 'PollDelete',
	PollRunningList = 'PollRunningList',
	PollView = 'PollView',
	PollCreate = 'PollCreate',
	PollListByTypeState = 'PollListByTypeState',
	PollListResults = 'PollListResults',
	PollApplicantList = 'PollApplicantList',
	PollApplicantUpdateStatus = 'PollApplicantUpdateStatus',
	PollWinner = 'PollWinner',
	PollHide = 'PollHide',
	PollSetOptResult = 'PollSetOptResult',

	// Application form
	ApplicationFormCreate = 'ApplicationFormCreate',
	ApplicationFormUpdate = 'ApplicationFormUpdate',
	ApplicationFormConfigUpdate = 'ApplicationFormConfigUpdate',
	ApplicationFormConfigGet = 'ApplicationFormConfigGet',
	ApplicationFormView = 'ApplicationFormView',
	ApplicationFormDelete = 'ApplicationFormDelete',
	ApplicationFormFieldGet = 'ApplicationFormFieldGet',
	ApplicationFormFieldCreate = 'ApplicationFormFieldCreate',
	ApplicationFormFieldUpdate = 'ApplicationFormFieldUpdate',
	ApplicationFormFieldDelete = 'ApplicationFormFieldDelete',
	ApplicationFormGroupGet = 'ApplicationFormGroupGet',
	ApplicationFormGroupUpdate = 'ApplicationFormGroupUpdate',

	// Refer Url
	ReferUrlAdd = 'ReferUrlAdd',
	ReferUrlUpdate = 'ReferUrlUpdate',
	ReferUrlList = 'ReferUrlList',
	ReferUrlChangeStatus = 'ReferUrlChangeStatus',

	// Explore All
	ExploreAll = 'ExploreAll',

	// Fan user
	FanUserGet = 'FanUserGet',
	FanUserList = 'FanUserList',

	// Vote Balancing
	VoteBalancingGetAll = 'VoteBalancingGetAll',
	VoteBalancingUpdate = 'VoteBalancingUpdate',
	VoteBalancingFind = 'VoteBalancingFind',
	VoteBalancingDelete = 'VoteBalancingDelete',
	VoteBalancingActivate = 'VoteBalancingActivate',

	// Chat Moderator
	ChatModeratorGetWildcardAccess = 'ChatModeratorGetWildcardAccess',
	ChatModeratorGetCreatorAccess = 'ChatModeratorGetCreatorAccess',
	ChatModeratorSetMessageFlag = 'ChatModeratorSetMessageFlag',
	ChatModeratorRemoveMessageFlag = 'ChatModeratorRemoveMessageFlag',
	ChatModeratorGetConfig = 'ChatModeratorGetConfig',
	ChatModeratorConfigUpdate = 'ChatModeratorConfigUpdate',
	ChatModeratorBanUser = 'ChatModeratorBanUser',
	ChatModeratorUnBanUser = 'ChatModeratorUnBanUser',
	ChatModeratorBanUserList = 'ChatModeratorBanUserList',
	ChatModeratorClear = 'ChatModeratorClear',

	// Gift Events
	GiftEventCreate = 'GiftEventCreate',
	GiftEventUpdate = 'GiftEventUpdate',
	GiftEventGet = 'GiftEventGet',
	GiftEventActivate = 'GiftEventActivate',

	// Early Access
	EarlyAccessGet = 'EarlyAccessGet',
	EarlyAccessGenerateCode = 'EarlyAccessGenerateCode',
	EarlyAccessCreate = 'EarlyAccessCreate',

	// Cache Refresh
	CacheRefresh = 'CacheRefresh',

	// Applicant
	ApplicantBulkAddToWinner = 'ApplicantBulkAddToWinner',

	//Fan Payment Transaction
	FanPaymentEnergyList = 'FanPaymentEnergyList',
	FanPaymentVipList = 'FanPaymentVipList',
	FanPaymentDirectPurchaseList = 'FanPaymentDirectPurchaseList',
	FanPaymentSuperSmsList = 'FanPaymentSuperSmsList',
	FanPaymentTipList = 'FanPaymentTipList',
	FanPaymentSignUpList = 'FanPaymentSignUpList',
	FanPaymentAllList = 'FanPaymentAllList',

	// Creator Payment
	CreatorPayment = 'CreatorPayment',
	CreatorPaymentSubscriptionList = 'CreatorPaymentSubscriptionList',

	//Creator Add Bonus
	BonusList = 'BonusList',
	BonusCredit = 'BonusCredit',

	//Sms-Package
	SmsPackageList = 'SmsPackageList',
	SmsPackageAdd = 'SmsPackageAdd',
	SmsPackageUpdate = 'SmsPackageUpdate',
	SmsPackageDelete = 'SmsPackageDelete',
	SmsPackageIncreases = 'SmsPackageIncreases',

	//Assigned Sms Credits
	AssignedSmsCredits = 'AssignedSmsCredits',

	//Dashboard
	DashboardView = 'DashboardView',

	//Chat
	ChatExport = 'ChatExport',

	//Vault
	FolderGet = 'FolderGet',
	FolderAdd = 'FolderAdd',
	FolderMediaAdd = 'FolderMediaAdd',
	FolderMediaUpdate = 'FolderMediaUpdate',
	FolderMediaGet = 'FolderMediaGet',
	FolderDelete = 'FolderDelete',
	FolderMediaDelete = 'FolderMediaDelete',
	FolderUpdate = 'FolderUpdate',
	FolderMediaUpdateItem = 'FolderMediaUpdateItem',
	FolderMediaSafe = 'FolderMediaSafe',

	//Bmmanagement
	BMMaster = 'BMMaster',
	BillingUpdate = 'BillingUpdate',

	//Billing
	BillingView = 'BillingView',

	//Subscriptions
	FanSubscriptionCancel = 'FanSubscriptionCancel',

	// Customer Info, Bank Details, Affiliates (view)
	CustomerInfoView = 'CustomerInfoView',
	BankDetailsView = 'BankDetailsView',
	AffiliatesView = 'AffiliatesView',

	CreditNotesList = 'CreditNotesList',
	CreditNotesGet = 'CreditNotesGet',
	CreditNotesMakeApprove = 'CreditNotesMakeApprove',
	CreditNotesMakePaid = 'CreditNotesMakePaid',
	CreditNotesUpdate = 'CreditNotesUpdate',
	CreditNotesRegenerate = 'CreditNotesRegenerate',
	CreditNotesMakeNotRelevant = 'CreditNotesMakeNotRelevant',
	CreditNotesSetNote = 'CreditNotesSetNote',
	CreditNotesPreview = 'CreditNotesPreview',
	CreditNotesRevertStatus = 'CreditNotesRevertStatus',

	//Telegram groups
	TelegramGroupList = 'TelegramGroupList',
	TelegramGroupUpdate = 'TelegramGroupUpdate',

	//Telegram Messages
	TelegramMessageList = 'TelegramMessageList',
	TelegramMessageSend = 'TelegramMessageSend',

	// AI
	AiConversationList = 'AiConversationList',
	AiConversationAsk = 'AiConversationAsk',
	AiConversationGet = 'AiConversationGet',
	AiConversationUpdateTitle = 'AiConversationUpdateTitle',
	AiConversationDelete = 'AiConversationDelete'
}

export enum PayoutStatusTypes {
	InProgress = 'inprogress',
	Refunded = 'refunded',
	Blocked = 'blocked',
	Cancelled = 'cancelled',
	Success = 'success',
	Unclaimed = 'unclaimed'
}

export enum PayoutModes {
	Auto = 'A',
	Manual = 'M'
}

export enum CreatorRevenueTypes {
	SmsPayment = 'Sms Payment',
	Subscription = 'Subscription',
	FanPaymentEnergy = 'Energy Payment',
	FanPaymentSuperSms = 'Super Sms Payment',
	FanPaymentVipPurchase = 'Vip Purchase',
	FanPaymentDirectPurchase = 'Direct Purchase',
	FanTip = 'Tip',
	payToSignUp = 'Pay To Signup',
	AllTransaction = 'All Transaction'
}
